"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var FormsHelperService = /** @class */ (function () {
    function FormsHelperService() {
    }
    FormsHelperService.prototype.isFormValid = function (form, touchFields) {
        var isFormValid = true;
        if (touchFields && (typeof form.$setDirty === 'function')) {
            form.$setDirty();
        }
        this.itarateFormFields(form, function (field) {
            if (touchFields && (typeof form.$setTouched === 'function')) {
                field.$setTouched();
            }
            if (field.$invalid) {
                isFormValid = false;
            }
        });
        isFormValid = isFormValid && form.$valid;
        return isFormValid;
    };
    FormsHelperService.prototype.resetForm = function (form) {
        this.itarateFormFields(form, function (field) {
            field.$setPristine();
            field.$setUntouched();
        });
        form.$setUntouched();
        form.$setPristine();
    };
    FormsHelperService.prototype.itarateFormFields = function (form, callback) {
        if (typeof callback !== 'function') {
            return;
        }
        for (var property in form) {
            if (!form.hasOwnProperty(property) || _.startsWith(property, '$')) {
                continue;
            }
            var formField = form[property];
            if (!formField) {
                continue;
            }
            callback(formField);
        }
    };
    return FormsHelperService;
}());
exports.FormsHelperService = FormsHelperService;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9ybXNIZWxwZXIuc2VydmljZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImZvcm1zSGVscGVyLnNlcnZpY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFFQSwwQkFBNEI7QUFFNUI7SUFBQTtJQXFEQSxDQUFDO0lBbkRVLHdDQUFXLEdBQWxCLFVBQW1CLElBQXFCLEVBQUUsV0FBcUI7UUFDM0QsSUFBSSxXQUFXLEdBQUcsSUFBSSxDQUFDO1FBRXZCLElBQUksV0FBVyxJQUFJLENBQUMsT0FBTyxJQUFJLENBQUMsU0FBUyxLQUFLLFVBQVUsQ0FBQyxFQUFFO1lBQ3ZELElBQUksQ0FBQyxTQUFTLEVBQUUsQ0FBQztTQUNwQjtRQUVELElBQUksQ0FBQyxpQkFBaUIsQ0FBQyxJQUFJLEVBQUUsVUFBQyxLQUFLO1lBQy9CLElBQUksV0FBVyxJQUFJLENBQUMsT0FBTyxJQUFJLENBQUMsV0FBVyxLQUFLLFVBQVUsQ0FBQyxFQUFFO2dCQUN6RCxLQUFLLENBQUMsV0FBVyxFQUFFLENBQUM7YUFDdkI7WUFFRCxJQUFJLEtBQUssQ0FBQyxRQUFRLEVBQUU7Z0JBQ2hCLFdBQVcsR0FBRyxLQUFLLENBQUM7YUFDdkI7UUFDTCxDQUFDLENBQUMsQ0FBQztRQUVILFdBQVcsR0FBRyxXQUFXLElBQUksSUFBSSxDQUFDLE1BQU0sQ0FBQztRQUV6QyxPQUFPLFdBQVcsQ0FBQztJQUN2QixDQUFDO0lBRU0sc0NBQVMsR0FBaEIsVUFBaUIsSUFBcUI7UUFDbEMsSUFBSSxDQUFDLGlCQUFpQixDQUFDLElBQUksRUFBRSxVQUFDLEtBQUs7WUFDL0IsS0FBSyxDQUFDLFlBQVksRUFBRSxDQUFDO1lBQ3JCLEtBQUssQ0FBQyxhQUFhLEVBQUUsQ0FBQztRQUMxQixDQUFDLENBQUMsQ0FBQztRQUVILElBQUksQ0FBQyxhQUFhLEVBQUUsQ0FBQztRQUNyQixJQUFJLENBQUMsWUFBWSxFQUFFLENBQUM7SUFDeEIsQ0FBQztJQUVPLDhDQUFpQixHQUF6QixVQUEwQixJQUFxQixFQUFFLFFBQTZDO1FBQzFGLElBQUksT0FBTyxRQUFRLEtBQUssVUFBVSxFQUFFO1lBQ2hDLE9BQU87U0FDVjtRQUVELEtBQUssSUFBSSxRQUFRLElBQUksSUFBSSxFQUFFO1lBQ3ZCLElBQUksQ0FBQyxJQUFJLENBQUMsY0FBYyxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsQ0FBQyxVQUFVLENBQUMsUUFBUSxFQUFFLEdBQUcsQ0FBQyxFQUFFO2dCQUMvRCxTQUFTO2FBQ1o7WUFFRCxJQUFJLFNBQVMsR0FBRyxJQUFJLENBQUMsUUFBUSxDQUFDLENBQUM7WUFFL0IsSUFBSSxDQUFDLFNBQVMsRUFBRTtnQkFDWixTQUFTO2FBQ1o7WUFFRCxRQUFRLENBQUMsU0FBUyxDQUFDLENBQUM7U0FDdkI7SUFDTCxDQUFDO0lBQ0wseUJBQUM7QUFBRCxDQUFDLEFBckRELElBcURDO0FBckRZLGdEQUFrQiJ9